import { AxiosResponse } from 'axios'
import { createEffect, createEvent, createStore, forward } from 'effector'
import { ILicense } from '../types'
import api from '../../../../Auth/api'
import { IResponse } from '../../../../common/types/global.types'

export const $license = createStore<ILicense>({} as ILicense)
export const $licenseIsLoading = createStore<boolean>(false)

export const setlLicenseIsLoading = createEvent<boolean>()

forward({ from: setlLicenseIsLoading, to: $licenseIsLoading })

export const getLicenseFx = createEffect<
  void,
  AxiosResponse<IResponse<ILicense>>,
  any
>(async () => {
  setlLicenseIsLoading(true)
  return api.get('license/view')
})

$license.on(getLicenseFx.doneData, (_, { data }) => {
  return data.data
})

getLicenseFx.finally.watch(() => {
  setlLicenseIsLoading(false)
})
